/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_AngleInputs */

const en_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const de_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const fr_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const es_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const it_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const nl_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const pl_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const fi_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const da_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

const sv_story_bank_angle = /** @type {(inputs: Story_Bank_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angle`)
};

/**
* | output |
* | --- |
* | "Angle" |
*
* @param {Story_Bank_AngleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_angle = /** @type {((inputs?: Story_Bank_AngleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_AngleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_angle(inputs)
	if (locale === "fr") return fr_story_bank_angle(inputs)
	if (locale === "es") return es_story_bank_angle(inputs)
	if (locale === "it") return it_story_bank_angle(inputs)
	if (locale === "nl") return nl_story_bank_angle(inputs)
	if (locale === "pl") return pl_story_bank_angle(inputs)
	if (locale === "fi") return fi_story_bank_angle(inputs)
	if (locale === "da") return da_story_bank_angle(inputs)
	if (locale === "sv") return sv_story_bank_angle(inputs)
	return en_story_bank_angle(inputs)
});